import lang from 'config/lang';
import VueToast from './toast.vue';
let Toast = {};

// 避免重复install，设立flag
Toast.installed = false;

Toast.install = function (Vue, options) {
  if (Toast.installed) return;
  // 默认配置
  let opt = {
    defaultType: 'center',
    duration: 2000
  };

  // 传来的配置
  for (let i in options) {
    opt[i] = options[i];
  }

  Vue.prototype.$toast = function (toast, imgType, type) {
    // imgType: toast上方的图片，有'success', 'error'两类，默认为空
    let chooseType = type || opt.defaultType;
    if (document.querySelector('.toast-wrapper')) {
      // 如果页面上已经有了toast，则不再继续执行
      return;
    }
    let ToastContructor = Vue.extend(VueToast);
    const tpl = new ToastContructor().$mount(document.createElement("div"));
    tpl.message = lang(toast);
    tpl.position = chooseType;
    tpl.imgType = imgType;
    document.body.appendChild(tpl.$el); // 添加toast
    tpl.show = true;
    setTimeout(() => {
      tpl.show = false;
    }, opt.duration - 300);
    setTimeout(() => {
      // 在规定的时间内关闭toast
      document.body.removeChild(tpl.$el);
    }, opt.duration);
    // 阻止遮罩滑动
    document
      .querySelector('div.toast-wrapper')
      .addEventListener('touchmove', function (e) {
        e.stopPropagation();
        e.preventDefault();
      });
    Toast.installed = true;
  };

  ['bottom', 'top', 'center'].forEach(type => {
    Vue.prototype.$toast[type] = (text, img) => {
      return Vue.prototype.$toast(text, img, type);
    };
  });
};
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Toast);
}
export default Toast;
